import { Modal } from '../../components/ui';
// T270(6) — the '?' shortcut sheet. Its contents mirror hooks/useTriageKeyboard.js;
// a shortcut added there has to be added here too.
// T085 — Keyboard cheat-sheet. Toggle with `?`.
//
// T248 — was a hand-rolled overlay declaring `role="dialog" aria-modal="true"`
// with no focus trap, so Tab walked straight out of it into the page beneath —
// the one claim an aria-modal makes that this could not keep. Modal's `tone`
// doc names this panel explicitly ("ConfirmDialog / KeyboardHelp"), so it was
// always meant to live here; it just never moved.
export default function KeyboardHelpPanel({ onClose, onReplayTour }) {
  return (
    <Modal
      onClose={onClose}
      size="sm"
      tone="over"
      placement="center"
      ariaLabel="Keyboard shortcuts"
      title="Keyboard shortcuts"
      eyebrow="Active on the dashboard rec list · ignored while typing"
    >
      <div>
        <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 text-xs">
          {[
            ['j / ↓', 'next row'],
            ['k / ↑', 'previous row'],
            ['s', 'shortlist / unshortlist'],
            ['a', 'apply (move to Applied)'],
            ['d', 'dismiss (no reason)'],
            ['1 – 6', 'dismiss with a preset reason'],
            ['shift + D', 'dismiss with a written reason'],
            ['e', 'explain (✨ Claude)'],
            ['c', 'cover letter'],
            ['t', 'tailored CV'],
            ['o / Enter', 'open the drawer'],
            ['⌘K / Ctrl+K', 'command palette'],
            ['?', 'this panel'],
            ['Esc', 'close panels'],
          ].map(([key, action]) => (
            <li key={key} className="flex items-baseline gap-3">
              <kbd className="shrink-0 rounded border border-slate-700 bg-slate-950/40 px-1.5 py-0.5 font-mono text-[10px] text-slate-300">
                {key}
              </kbd>
              <span className="text-slate-300">{action}</span>
            </li>
          ))}
        </ul>
        {/* T256(2) — the tour moved here from the header: same one click to
            reach, no permanent seat next to the buttons used every day. */}
        <button
          type="button"
          onClick={onReplayTour}
          className="mt-5 rounded-md border border-slate-700 px-3 py-1.5 text-xs text-slate-300 transition hover:border-brand-600 hover:text-brand-400"
        >
          ↻ Replay the 3-step dashboard tour
        </button>
      </div>
    </Modal>
  );
}
